import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import { useDispatch, useSelector } from "react-redux";
import { tileTypes } from "../../utils/tileTypes";
import { tileSize } from "../../utils/tileSizes";
import { events } from "../../utils/mainTabs/events/events";
import { eventMyDrafts } from "../../utils/mainTabs/events/eventMyDrafts";
import { eventPublishedByMe } from "../../utils/mainTabs/events/eventPublishedByMe";
import { eventPublishedByOthers } from "../../utils/mainTabs/events/eventPublishedByOthers";
import { eventCreateTrainingType } from "../../utils/mainTabs/events/eventCreateTrainingType";
import { createPasscode } from "../../utils/mainTabs/events/createPasscode";
import { createNewEvent } from "../../utils/mainTabs/events/createNewEvent";
import {
  eventGetMyDraftsActionHandler,
  eventGetPublishedByMeActionHandler,
  eventGetPublishedByOthersActionHandler,
} from "../../store/actions/actionHandlers/eventActionHandler";
import {
  getMyProfileActionHandler,
  getUserRoleMenuForEventActionHandler,
} from "../../store/actions/actionHandlers/commonActionHandler";
import { FiRefreshCw } from "react-icons/fi";
import {
  eventGetMyDraftsAction,
  eventGetPublishedByMeAction,
  eventGetPublishedByOthersAction,
} from "../../store/actions/actionCreators/eventActionCreator";

const EventsPage = () => {
  const timerRef = useRef(180);
  const intervalRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const { tenantName } = useOutletContext();
  const eventState = useSelector((state) => state.eventReducer);
  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile, userRoleMenu } = commonState;
  const {
    eventMyDraftsCount,
    eventPublishedByMeCount,
    eventPublishedByOthersCount,
  } = eventState;
  const { navLinks: createTrainingNavLinks } = eventCreateTrainingType;
  const { navLinks: createNewEventNavLinks } = createNewEvent;
  const { navLinks: createPassCodeNavLinks, tiles: createPasscodeTiles } =
    createPasscode;
  const { name, buttons, tiles, path } = events;
  const { tiles: createNewEventTiles } = createNewEvent;

  const eventPath = path(tenantName);
  const eventMyDraftsPath = eventMyDrafts.path(tenantName);
  const eventPublishedByMePath = eventPublishedByMe.path(tenantName);
  const eventPublishedByOthersPath = eventPublishedByOthers.path(tenantName);
  const eventCreateTrainingTypePath = eventCreateTrainingType.path(tenantName);
  const createPasscodePath = createPasscode.path(tenantName);
  const createNewEventPath = createNewEvent.path(location, params, tenantName);
  const createNewEventEditPath = createNewEvent.editpath(tenantName);
  const createNewEventCopyPath = createNewEvent.copypath(tenantName);
  const createNewEventViewPath = createNewEvent.viewpath(tenantName);
  const [eventHeader, setEventHeader] = useState();
  const [eventTiles, setEventTiles] = useState([]);
  const [eventButtons, setEventButtons] = useState([]);
  const [eventNavLinks, setEventNavLinks] = useState([]);
  const [eventTileType, setEventTileType] = useState(tileTypes.DEFAULT);
  const [isEventStepTiles, setIsEventStepTiles] = useState(false);
  const [publishedEventLists, setPublishedEventLists] = useState([]);
  // Enabling and disabling Virtual & Live Quiz with MSOM
  const [roleMenu, setRoleMenu] = useState();
  const [roleTitle, setRoleTitle] = useState([]);
  const timerDisplayRef = useRef(null);
  const [refreshAPIS, setRefreshAPIS] = useState(false);

  useEffect(() => {
    if (userRoleMenu) {
      setRoleMenu(userRoleMenu);
    }
  }, [userRoleMenu]);
  useEffect(() => {
    if (roleMenu?.length > 0) {
      roleMenu?.map((item) => {
        setRoleTitle((prev) => [...prev, item?.Title]);
      });
    }
  }, [roleMenu?.length, setRoleTitle]);

  //Msom Disable and Enable Virtual & Live Event
  const [tenantProfile, setTenantProfile] = useState();
  const [isTenantProfileNameExist, setIsTenantProfileNameExist] = useState([]);

  useEffect(() => {
    dispatch(
      eventGetPublishedByMeActionHandler(
        "",
        1,
        1,
        () => {},
        () => {},
        () => {},
        true
      )
    );
    dispatch(
      eventGetPublishedByOthersActionHandler(
        "",
        1,
        1,
        () => {},
        () => {},
        () => {},
        true
      )
    );
  }, []);

  useEffect(() => {
    if (myProfile) {
      setTenantProfile(myProfile?.TenantFeatures);
    }
  }, [myProfile]);
  useEffect(() => {
    if (tenantProfile?.length > 0) {
      tenantProfile.map((item) => {
        setIsTenantProfileNameExist((prev) => [...prev, item?.Name]);
      });
    }
  }, [tenantProfile?.length]);
  useEffect(() => {
    if (
      location.pathname === eventMyDraftsPath ||
      location.pathname === eventPublishedByMePath ||
      location.pathname === eventPublishedByOthersPath
    ) {
      let tilesList = tiles(
        navigate,
        tenantName,
        eventMyDraftsCount,
        eventPublishedByMeCount,
        eventPublishedByOthersCount
      );
      let buttonList = buttons(navigate, tenantName);
      setEventTileType(tileTypes.DEFAULT);
      setIsEventStepTiles(false);
      setEventTiles(tilesList);
      setEventButtons(buttonList);
      setEventNavLinks([]);
      setEventHeader(name);
    } else if (location.pathname === eventCreateTrainingTypePath) {
      let navLinksList = createTrainingNavLinks(navigate, tenantName);
      setEventTiles([]);
      setEventButtons([]);
      setEventNavLinks(navLinksList);
      setEventHeader("");
    } else if (location.pathname.includes(createNewEventPath)) {
      let navLinksList = createNewEventNavLinks(navigate, location, tenantName);
      // let tilesList = createNewEventTiles(navigate);
      setEventTileType(tileTypes.DEFAULT);
      // setEventTiles(tilesList);
      setIsEventStepTiles(true);
      setEventButtons([]);
      setEventNavLinks(navLinksList);
      setEventHeader("");
    } else if (location.pathname.includes(createPasscodePath)) {
      let navLinksList = createPassCodeNavLinks(navigate, tenantName);
      let tilesList = createPasscodeTiles(navigate, tenantName);
      // if (
      //   !roleTitle.includes("LIVE_QUIZ_TEXT") ||
      //   !isTenantProfileNameExist.includes("LiveQuizzing")
      // ) {
      //   setEventTiles([tilesList[0]]);
      // } else if (
      //   !roleTitle.includes("VIRTUAL_QUIZ_TEXT") ||
      //   !isTenantProfileNameExist.includes("VirtualQuizzing")
      // ) {
      //   setEventTiles([tilesList[1]]);
      // } else {
      setEventTiles(tilesList);
      // }
      setEventTileType(tileTypes.DEFAULT);
      setIsEventStepTiles(false);
      setEventButtons([]);
      setEventNavLinks(navLinksList);
      setEventHeader("");
    }
  }, [
    tenantName,
    eventMyDraftsPath,
    eventPublishedByMePath,
    eventPublishedByOthers,
    eventCreateTrainingTypePath,
    createPasscodePath,
    createPassCodeNavLinks,
    createPasscodeTiles,
    createNewEventNavLinks,
    createTrainingNavLinks,
    location,
    params,
    name,
    buttons,
    tiles,
    navigate,
    eventMyDraftsCount,
    eventPublishedByMeCount,
    eventPublishedByOthersCount,
    roleTitle?.length,
  ]);
  useEffect(() => {
    if (location.pathname === eventPath) {
      navigate(eventMyDraftsPath);
    }
    if (
      (eventMyDraftsCount === null && eventPublishedByMeCount == null) ||
      (eventMyDraftsCount === 0 && eventPublishedByMeCount == 0) ||
      location.pathname === createPasscodePath
    ) {
      if (
        location.pathname === eventMyDraftsPath ||
        location.pathname === createPasscodePath
      ) {
        dispatch(
          eventGetPublishedByMeActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          eventGetPublishedByOthersActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
      } else if (
        location.pathname === eventPublishedByMePath ||
        location.pathname === createPasscodePath
      ) {
        dispatch(
          eventGetMyDraftsActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          eventGetPublishedByOthersActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
      } else if (
        location.pathname === eventPublishedByOthers ||
        location.pathname === createPasscodePath
      ) {
        dispatch(
          eventGetPublishedByMeActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          eventGetMyDraftsActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
      }
    }
  }, [
    eventPath,
    eventMyDraftsPath,
    eventPublishedByMePath,
    eventPublishedByOthers,
    createPasscodePath,
    location,
    navigate,
    dispatch,
    eventMyDraftsCount,
    eventPublishedByMeCount,
    location.pathname,
  ]);

  const handleRefreshAPIs = useCallback(() => {
    setRefreshAPIS(true);
    dispatch(eventGetMyDraftsAction(null));
    dispatch(eventGetPublishedByMeAction(null));
    dispatch(eventGetPublishedByMeAction(null));

    if (location.pathname === eventMyDraftsPath) {
      dispatch(
        eventGetPublishedByMeActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        eventGetPublishedByOthersActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
    } else if (location.pathname === eventPublishedByMePath) {
      dispatch(
        eventGetMyDraftsActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        eventGetPublishedByOthersActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
    } else if (location.pathname === eventPublishedByOthersPath) {
      dispatch(
        eventGetPublishedByMeActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        eventGetMyDraftsActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
    }
  }, [
    dispatch,
    location.pathname,
    eventMyDraftsPath,
    eventPublishedByMePath,
    eventPublishedByOthersPath,
  ]);
  const startTimer = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      timerRef.current -= 1;
      if (timerDisplayRef.current) {
        timerDisplayRef.current.textContent = `${timerRef.current}`;
      }
      if (timerRef.current <= 0) {
        clearInterval(intervalRef.current);
        handleRefreshAPIs();
        timerRef.current = 180;
        if (timerDisplayRef.current) {
          timerDisplayRef.current.textContent = `${timerRef.current}`;
        }
        startTimer();
      }
    }, 1000);
  }, [handleRefreshAPIs]);

  useEffect(() => {
    if (
      location.pathname === eventMyDraftsPath ||
      location.pathname === eventPublishedByMePath ||
      location.pathname === eventPublishedByOthersPath
    ) {
      startTimer();
    } else {
      timerRef.current = 180;
      if (timerDisplayRef.current) {
        timerDisplayRef.current.textContent = `${timerRef.current}`;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [
    location.pathname,
    eventMyDraftsPath,
    eventPublishedByMePath,
    eventPublishedByOthersPath,
    startTimer,
  ]);

  useEffect(() => {
    if (location.pathname === eventPath) {
      navigate(eventMyDraftsPath);
    }
    if (
      eventMyDraftsCount === null &&
      eventPublishedByMeCount === null &&
      eventPublishedByOthersCount === null
    ) {
      handleRefreshAPIs();
    }
  }, [
    location.pathname,
    eventPath,
    eventMyDraftsCount,
    eventPublishedByMeCount,
    eventPublishedByOthersCount,
    eventMyDraftsPath,
    eventPublishedByMePath,
    eventPublishedByOthersPath,
    handleRefreshAPIs,
    navigate,
  ]);

  const handleRefreshIcon = () => {
    timerRef.current = 180;
    if (timerDisplayRef.current) {
      timerDisplayRef.current.textContent = `${timerRef.current}`;
    }
    handleRefreshAPIs();
    startTimer();
  };

  return (
    <>
      {(location.pathname == eventMyDraftsPath ||
        location.pathname === eventPublishedByMePath ||
        location.pathname === eventPublishedByOthersPath) && (
        <div
          style={{
            fontSize: "1.6rem",
            textAlign: "right",
            padding: "2rem 2rem 0rem",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          Page will get refreshed in
          <span ref={timerDisplayRef}>{timerRef.current}</span> Seconds
          <div
            onClick={() => handleRefreshIcon()}
            style={{ cursor: "pointer", display: "flex" }}
          >
            <FiRefreshCw />
          </div>
        </div>
      )}
      <MainLayout
        heading={eventHeader}
        buttons={eventButtons}
        navLinks={eventNavLinks}
        tiles={eventTiles}
        tileType={eventTileType}
        tileSize={tileSize.LARGE}
        isStepTile={isEventStepTiles}
      >
        <Outlet
          context={{
            eventTiles,
            setEventTiles,
            setEventButtons,
            tenantName,
            eventPath,
            createNewEventPath,
            createNewEventEditPath,
            createNewEventCopyPath,
            createNewEventViewPath,
            roleTitle,
            isTenantProfileNameExist,
            refreshAPIS,
            setRefreshAPIS,
          }}
        />
      </MainLayout>
    </>
  );
};

export default EventsPage;
